import { render, staticRenderFns } from "./RemoteShareDialog.vue?vue&type=template&id=3dcfb154&scoped=true"
import script from "./RemoteShareDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoteShareDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RemoteShareDialog.vue?vue&type=style&index=0&id=3dcfb154&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcfb154",
  null
  
)

export default component.exports